import PortalUtils from "@/modules/dashboards/PortalUtils";
const dashboardItems = await PortalUtils.getDashboardItems()
const childRoutes = dashboardItems.map(item => {
    return {
        path: `/${item.id}`,
        component: () => import(/* webpackChunkName: "facilities" */ '../components/FacilitiesDashboard.vue'),
        props: { dashboardId: item.id },
        meta: {
            title: `${item.title.toUpperCase()}`,
            gtm: `${item.title.toLowerCase().replace(/\s+/g, '-')}`,
            icon: 'mdi-view-dashboard'
        }
    }
})

export default [
    {
        path: '/dashboards',
        name: 'dashboards',
        component: () => import(/* webpackChunkName: "account-request" */ '../pages/Dashboards.vue'),
        meta: {
            title: 'DASHBOARDS',
            icon: 'mdi-view-dashboard',
            displayInNavigation: true,
            gtm: 'facility-dashboards',
        },
        children: childRoutes
    }
]
